// @flow
import type { Gathering } from 'types'
import { get } from 'util/api'

type AllParams = {
  schoolId?: number,
  ids?: number[],
  beginsAfter?: string,
}

export function all(params: AllParams): Promise<Gathering[]> {
  return get('/api/gatherings', params).then(response => response.json.gatherings)
}

export function fetch(id: number): Promise<Gathering> {
  return get(`/api/gatherings/${id}`).then(response => response.json.gathering)
}
